import { SvgIcon, SvgIconProps } from '@material-ui/core';

const CheckCompleteIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <circle fill="currentColor" cx="12" cy="12" r="12"></circle>
          <g
            transform="translate(5.301000, 7.197000)"
            fill="#FFFFFF"
            fillRule="nonzero"
          >
            <path d="M11.355,0.351 L4.299,7.407 L2.043,5.151 C1.575,4.683 0.819,4.683 0.351,5.151 C-0.117,5.619 -0.117,6.375 0.351,6.843 L3.459,9.951 C3.927,10.419 4.683,10.419 5.151,9.951 L13.059,2.043 C13.527,1.575 13.527,0.819 13.059,0.351 C12.591,-0.117 11.823,-0.117 11.355,0.351 Z"></path>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default CheckCompleteIcon;
